// inputs.js
import { validateRequired, validateLength, validateURL, validateNonZeroInteger, validateNotNull,validateImageRequired } from "../../../../helpers/validationsForm";

const Inputs = [
  {
    id: 1,
    label: "Descripción",
    name: "descripcion",
    type: "text",
    placeholder: "Ingrese la descripción",
    validation: (value, form) => {
      // Validación requerida
      const requiredError = validateRequired(value);
      if (requiredError) {
        return requiredError;
      }

      // Validación de longitud
      const lengthError = validateLength(value, { minLength: 2, maxLength: 40 });
      if (lengthError) {
        return lengthError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 5,
    label: "Imagen",
    name: "imagen",
    type: "file",
    placeholder: "Ingrese la descripción de la imagen",
    validation: (value, file) => {
      // Validación requerida
      const requiredError = validateImageRequired(value,file);
      if (requiredError) {
        return requiredError;
      }

      // Si no hay errores
      return null;
    }
  },
  {
    id: 4,
    label: "URL",
    name: "url",
    type: "text",
    title: "Por favor, ingrese una URL válida. Ejemplo: https://example.com",
    validation: (value, form) => {
      // Validación de correo
      const urlError = validateURL(value);
      if (urlError) {
        return urlError;
      }
      // Si no hay errores
      return null;
    }
  },
  {
    id: 3,
    label: "Target",
    name: "target",
    type: "select",
    options: [
      { value: 'true', label: 'Misma Página' },
      { value: 'false', label: 'Nueva Página' },
    ],
    placeholder: "Abrir en una...",
  },

];

export default Inputs;
